"use strict";
const angular = require("angular");

/*@ngInject*/
export function dbFactoryService($http) {
  var dbFactory = {};

  //Get details for single parcel: parcel_id
  dbFactory.getParcelDetail = function (id) {
    console.log("in the factory: ", id);
    return $http.get("/api/data/hess/parcelDetails/" + id);
  };

    //Get details for single public parcel: parcel_id
    dbFactory.getPublicParcelDetail = function (id) {
      console.log("in the factory: ", id);
      return $http.get("/api/data/public/hess/parcelDetails/" + id);
    };

  dbFactory.getTractDetail = function (id) {
    console.log("in the factory tracts: ", id);
    return $http.get("/api/data/hess/tractDetails/" + id);
  };

  dbFactory.getCurrentUser = function(){
    return $http.get('/api/users/general')
  }

  // Public API here
  return dbFactory;
}

export default angular
  .module("hessApplicationApp.dbFactory", [])
  .factory("dbFactory", dbFactoryService).name;



// WEBPACK FOOTER //
// ./client/components/factories/dbFactory/dbFactory.service.js